
import Swiper from "./swiper-bundle.esm.browser.min.js";
if (!customElements.get("card-slider")) {
    customElements.define(
      "card-slider",
      class CardSlider extends HTMLElement {
        constructor() {
          super();
          this.swiper = null; 
          this.filterSlides = this.filterSlides.bind(this);

        }
  
        connectedCallback() {
            this.isMobileSliderEnable = this.dataset.mobileSlider || false;
            this.initializeSwiper();
        }

        isMobile() {
          return window.innerWidth <= 1199;
        }

        filterSlides() {
          // if (!this.isMobileSliderEnable) return;

          const slides = Array.from(this.querySelectorAll('.swiper-slide'));

          const firstSlide = slides.length > 1 ? slides[0] : null;
          const lastSlide = slides.length > 3 ? slides[slides.length - 1] : null;

          const deviceType = this.isMobile() ? 'mobile' : 'desktop';

          if (deviceType === 'mobile') {
            if (lastSlide) lastSlide.style.display = 'none';
            if (firstSlide) firstSlide.style.display = null; 
          } else {
            if (lastSlide) lastSlide.style.display = null;
            if (firstSlide) firstSlide.style.display = 'none';
          }

          this.swiper?.update();
        }

        initializeSwiper() {
            const swiperContainer = this.querySelector('.swiper-slider');
            const nextEl = this.querySelector('.swiper-button-next');
            const prevEl = this.querySelector('.swiper-button-prev');
            const pagination = this.querySelector('.swiper-pagination');
    
            if (!swiperContainer || !nextEl || !prevEl) {
              console.error('Swiper initialization failed due to missing elements.');
              return;
            }
    
            this.swiper = new Swiper(swiperContainer, {
              loop: false,
              navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
              },
              pagination: {
                el: pagination,
              },
              breakpoints: {
                "320": {
                  enabled: this.isMobileSliderEnable
                },
                "900": {
                  enabled: true
                }
              },
              on: {
                init: () => {
                  this.filterSlides();
                },
                resize: () => {
                  this.filterSlides();
              }
              }
            });
          }
    
          disconnectedCallback() {
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
          }

    },
    );
  }
  